// CLARTEXT SPRACHE V1 – Phase 2: Deutsche Basis-Texte der Mitarbeiter-App.
// Quelle der Wahrheit. Alle anderen Sprachdateien (en/pl/ro/uk/bg/tr)
// re-exportieren in Phase 2 EXAKT diese deutschen Werte (Platzhalter, KEINE
// Übersetzung). Weltinhalte (Welt-Titel, Fragen, Antwortoptionen, GBU-/BA-Texte)
// sind hier bewusst NICHT enthalten und bleiben unverändert deutsch.
const de = {
  // Gemeinsame
  "common.loading": "Lade…",

  // PIN-Login (/monteur/login)
  "login.eyebrow": "Anmeldung",
  "login.title": "Deine PIN",
  "login.subtitle": "Firmen-Code + 4-stellige PIN von deinem Chef.",
  "login.companyCodeLabel": "Firmen-Code",
  "login.companyCodePlaceholder": "z. B. LUMPE",
  "login.submitting": "Anmeldung läuft…",
  "login.backAria": "Zurück zum Login",
  "login.errorNoCode": "Bitte zuerst den Firmen-Code eingeben.",
  "login.errorUnknown": "Firma oder PIN unbekannt.",

  // Aufgabenliste (/monteur)
  "tasks.companyFallback": "Ihr Betrieb",
  "tasks.portalSubtitle": "Unterweisungsportal",
  "tasks.loggedInAs": "Angemeldet als",
  "tasks.heading": "Deine Aufgaben",
  "tasks.openCount": "{count} offen",
  "tasks.emptyToday": "Heute keine offenen Aufgaben.",
  "tasks.newBanner": "Du hast {count} neue Unterweisung(en) seit deinem letzten Besuch.",
  "tasks.newBadge": "Neu",
  "tasks.newBannerDismissAria": "Hinweis schließen",
  "tasks.backAria": "Zurück zur Übersicht",
  "home.tasksTitle": "Unterweisungen",
  "home.searchTitle": "Nachschlagewerk",
  "home.searchSubtitle": "Sicherheits-Infos schnell nachschlagen",
  "home.hspTitle": "Hautschutzplan",
  "home.hspSubtitle": "Hautschutz und Handschuhauswahl im Überblick",
  "home.driverTitle": "Führerscheinkontrolle",
  "home.driverOpen": "Bitte Führerschein einreichen",
  "home.driverSubmitted": "Wartet auf Prüfung durch den Betrieb",
  "home.driverUpToDate": "Aktuell gültig",
  "home.settingsTitle": "Einstellungen",
  "home.settingsSubtitle": "E-Mail & Sprache verwalten",
  "home.comingSoon": "Bald verfügbar",
  "home.newBubbleAria": "{count} neue Unterweisungen",
  "settings.profileTitle": "Profil",
  "settings.profileHint": "Name und Betrieb werden vom Betrieb gepflegt.",
  "settings.emailTitle": "E-Mail für Benachrichtigungen",
  "settings.emailPurpose": "Wird ausschließlich verwendet, um dich über neue Unterweisungen zu informieren.",
  "settings.emailPlaceholder": "name@beispiel.de",
  "settings.emailSave": "Speichern",
  "settings.emailSaved": "Gespeichert",
  "settings.emailInvalid": "Bitte gültige E-Mail-Adresse eingeben.",
  "settings.emailRemoveHint": "Feld leeren und speichern, um dich wieder abzumelden.",
  "settings.saveError": "Speichern fehlgeschlagen. Bitte erneut versuchen.",
  "settings.privacyLink": "Datenschutzerklärung",
  "settings.consentLabel": "Ich möchte per E-Mail über neue Unterweisungen informiert werden.",
  "settings.languageTitle": "Sprache",
  "settings.langNotBooked": "Ausgegraute Sprachen sind von Ihrem Unternehmen noch nicht gebucht. Sprechen Sie Ihren Chef an, wenn Sie eine davon nutzen möchten.",
  "tasks.quickLookup": "Schnell nachschlagen",
  "tasks.doneHeading": "Bereits erledigt",
  "tasks.dueLabel": "Fällig",
  "tasks.doneAtLabel": "Erledigt am",
  "tasks.logoutAria": "Abmelden",

  // CLARTEXT · A1 (Feb 2026) – Aushangpflicht-Anzeige (Mitarbeiter-Link + Seite).
  "aushang.linkTitle": "Aushangpflichtige Gesetze und Vorschriften",
  "aushang.linkSubtitle": "Amtliche Originaltexte nachschlagen",
  "aushang.pageTitle": "Aushangpflichtige Gesetze und Vorschriften",
  "aushang.categoryAllgemein": "Allgemeine gesetzliche Grundlagen",
  "aushang.categoryDguv": "DGUV-Vorschriften und technische Regeln",

  // Aufgabendetail (/monteur/aufgabe/:id)
  "aufgabe.notFound": "Aufgabe nicht gefunden.",
  "aufgabe.wrongOne": "Eine Antwort war nicht korrekt. Bitte erneut beantworten.",
  "aufgabe.wrongMany":
    "{count} Antworten waren nicht korrekt. Bitte erneut beantworten.",
  "aufgabe.saveFailed": "Speichern fehlgeschlagen. Bitte erneut versuchen.",
  "aufgabe.doneTitle": "Geschafft!",
  "aufgabe.doneBody":
    "Die Unterweisung „{title}“ ist erledigt. Dein Nachweis wurde automatisch erstellt und liegt in der Prüfmappe deines Betriebs.",
  "aufgabe.backToTasks": "Zurück zu meinen Aufgaben",
  "aufgabe.stepContent": "Inhalt",
  "aufgabe.stepQuestion": "Frage {current} von {total}",
  "aufgabe.backShort": "Aufgaben",
  "aufgabe.readCalm": "Bitte einmal in Ruhe lesen.",
  "aufgabe.questionsFollow": "Danach folgen {count} kurze Verständnisfragen.",
  "aufgabe.questionLabel": "Verständnisfrage {current} / {total}",
  "aufgabe.wrongAgain":
    "Diese Antwort war beim letzten Versuch nicht korrekt. Bitte erneut wählen.",
  "aufgabe.prev": "Zurück",
  "aufgabe.saving": "Speichere…",
  "aufgabe.finish": "Unterweisung abschließen",
  "aufgabe.toQuestions": "Zu den Fragen",
  "aufgabe.next": "Weiter",

  // Nachschlage-Suche (Komponente MonteurWeltSuche)
  "suche.placeholder": "Nachschlagen – z. B. „Akku“, „Brille“, „Leiter“…",
  "suche.inputAria": "Dokumentationswelt suchen",
  "suche.matchIn": "Treffer in {label}:",
  "suche.empty": "Keine passende Dokumentationswelt gefunden.",
  "suche.emptyHint": "Versuch ein anderes Wort, z. B. „PSA“ oder „Verband“.",

  // Welt-Nachschlagewerk (/monteur/welt/:id) – NUR UI-Rahmen/Labels.
  // Die eigentlichen Weltinhalte (Titel, Beschreibungen, Gefährdungen,
  // Maßnahmen-Texte, Fragen, Optionen) sind Daten und bleiben deutsch.
  "welt.headerTitle": "Nachschlagen",
  "welt.backAria": "Zurück",
  "welt.errorNotAvailable": "Diese Dokumentationswelt ist aktuell nicht verfügbar.",
  "welt.errorLoad": "Die Welt konnte nicht geladen werden.",
  "welt.backToTasks": "Zurück zu meinen Aufgaben",
  "welt.loading": "Lade Welt…",
  "welt.doctype": "Nachschlagewerk",
  "welt.versionLabel": "Version",
  "welt.gbuTitle": "Gefährdungsbeurteilung",
  "welt.noHazards": "Keine Einzel-Gefährdungen dokumentiert.",
  "welt.residualRisk": "Restrisiko:",
  "welt.measureTechnical": "Technisch",
  "welt.measureOrganizational": "Organisatorisch",
  "welt.measurePersonal": "Persönlich",
  "welt.responsible": "Verantwortlich:",
  "welt.baTitle": "Betriebsanweisung",
  "welt.baSubtitle": "Nach TRBS / GefStoffV / BetrSichV",
  "welt.mainHazards": "Hauptgefahren",
  "welt.protectiveMeasures": "Schutzmaßnahmen & Verhaltensregeln",
  "welt.emergency": "Im Notfall",
  "welt.firstAid": "Erste Hilfe",
  "welt.disposalHazmat": "Lagerung & Entsorgung",
  "welt.disposalVehicle": "Abstellen",
  "welt.disposalDefault": "Außerbetriebnahme",
  "welt.instructionTitle": "Unterweisung",
  "welt.instructionSubtitle": "Nach DGUV V1 §4",
  "welt.visualTitle": "Visuelle Lernhilfen",
  "welt.visualSubtitle":
    "Unterstützen das Verständnis – verändern keine Inhalte, Nachweise oder PDFs",
  "welt.questionsTitle": "Verständnisfragen",
  "welt.questionsSubtitle":
    "{count} Fragen — Selbst-Check, ohne Markierung der richtigen Antwort",
  "welt.maintenanceTitle": "Prüf- & Wartungshinweise",
  "welt.maintenanceSubtitle": "Nach BetrSichV / UVV",
  "welt.performedBy": "Durchführung:",
  "welt.recommendedCheck": "Empfohlene Sachkundigen-Prüfung:",
  "welt.recurrenceTitle": "Wiedervorlage-Zyklen",
  "welt.recurrenceSubtitle": "Pro Baustein – automatisch vom System überwacht",
  "welt.recurrenceUnterweisung": "Unterweisung",
  "welt.recurrenceGbuReview": "Gefährdungsbeurteilung – Review",
  "welt.recurrenceWartung": "Wartung / Prüfung",
  "welt.recurrence.none": "–",
  "welt.recurrence.einmalig": "Einmalig",
  "welt.recurrence.monatlich": "Monatlich",
  "welt.recurrence.vierteljaehrlich": "Vierteljährlich",
  "welt.recurrence.halbjaehrlich": "Halbjährlich",
  "welt.recurrence.jaehrlich": "Jährlich",
  "welt.recurrence.zwei_jahre": "Alle 2 Jahre",

  // Aufgaben-Status (StatusBadge) – Phase 7E P0.2: vom hartcodierten Wert in den
  // i18n-Layer überführt. Quelle der Wahrheit; gleiche Keys in allen Sprachen.
  "status.offen": "Offen",
  "status.erledigt": "Erledigt",
  "status.ueberfaellig": "Überfällig",

  // CLARTEXT SPRACHE V1.1 (Demo-Feinschliff) – feste Abschnitts-Überschriften der
  // Unterweisungs-Inhalte (content[].heading). REINER Anzeige-Lookup; die in der DB
  // gespeicherten Daten + Beweiskette (Nachweis/PDF/WORM/Hash) bleiben deutsch/unverändert.
  "contentHeading.Worum geht es?": "Worum geht es?",
  "contentHeading.Welche Gefahren bestehen?": "Welche Gefahren bestehen?",
  "contentHeading.Vor Arbeitsbeginn beachten": "Vor Arbeitsbeginn beachten",
  "contentHeading.Während der Arbeit beachten": "Während der Arbeit beachten",
  "contentHeading.Nach der Arbeit beachten": "Nach der Arbeit beachten",

  // CLARTEXT SPRACHE AP-V1 – sprachneutrale UI-/Präsentationslabels der visuellen
  // Lernschicht (VLOs). REINE Anzeige-/Struktur-Labels. Fachliche Inhalte
  // (Backend-`vlo.label`, Kartentexte aus `display`) bleiben unberührt (AP-V2/V3).
  "vlo.safetySymbols.title": "Sicherheitssymbole",
  "vlo.safetySymbols.hint":
    "Diese Symbole unterstützen die Unterweisung. Maßgeblich ist immer der Text.",
  "vlo.psaSummary.title": "PSA-Zusammenfassung",
  "vlo.hazardMarkers.title": "Gefahrenmarkierungen",
  "vlo.learningFocus.title": "Lernfokus",
  "vlo.richtigFalsch.title": "Richtig & Falsch",
  "vlo.richtigFalsch.correct": "Richtig",
  "vlo.richtigFalsch.wrong": "Falsch",

  // PRINT.1 (Juni 2026) – Druck-/Plakat-Labels (UI-Hülsen des gedruckten Plakats).
  // Fachinhalte (Titel, Gefahren, Regeln) kommen weiterhin aus `display`.
  "plakat.eyebrow": "Unterweisungsplakat",
  "plakat.subtitle": "Sicher arbeiten – wichtigste Regeln auf einen Blick",
  "plakat.symbols": "Sicherheitszeichen",
  "plakat.hazards": "Gefahren",
  "plakat.richtigFalsch": "Richtig & Falsch",
  "plakat.correct": "Richtig",
  "plakat.wrong": "Falsch",
  "plakat.psa": "Persönliche Schutzausrüstung (PSA)",
  "plakat.rules": "Wichtigste Regeln",
  "plakat.qrTitle": "Welt direkt öffnen",
  "plakat.qrText": "QR-Code mit dem Handy scannen, PIN eingeben – die Dokumentationswelt öffnet sich sofort.",
  "plakat.footerHint": "Dieses Plakat unterstützt die Unterweisung. Maßgeblich bleibt die vollständige Unterweisung.",
  "plakat.moreInFull": "Weitere Inhalte in der vollständigen Unterweisung",

  // AP-PLAKAT-UX (Juni 2026) – Gruppen-Unterüberschriften + Mehrseitigkeit.
  "plakat.hazardsSub": "Was kann passieren?",
  "plakat.correctSub": "So wird sicher gearbeitet.",
  "plakat.wrongSub": "So darf nicht gearbeitet werden.",
  "plakat.continued": "Fortsetzung",
  "plakat.page": "Seite",

  // Gemeinsame UI-Chrome-Texte (i18n-Nachbesserung Juni 2026)
  "common.back": "Zurück",
  "common.notEnabled": "Diese Anzeige ist für Ihren Betrieb nicht freigeschaltet.",

  // Aushang-Bedienoberfläche (Gesetzestexte selbst bleiben amtlich deutsch)
  "aushang.kicker": "Aushangpflicht",
  "aushang.intro": "Zu den amtlichen Originaltexten. Der Betreiber pflegt die Liste zentral; Aktualisierungen werden vor der Übernahme geprüft.",
  "aushang.loadError": "Aushang konnte nicht geladen werden.",
  "aushang.listLoading": "Lade Aushang…",
  "aushang.listEmpty": "Aktuell keine Einträge — der Betreiber pflegt die Liste über die Betreiberkonsole.",
  "aushang.categoryEmpty": "Keine Einträge in dieser Kategorie.",

  // Hautschutzplan-Ansicht (das Plakat selbst bleibt deutsch)
  "hsp.kicker": "Handschutzplan",
  "hsp.titleFallback": "Hautschutz- und Handschutzplan",
  "hsp.loadError": "Der Handschutzplan konnte nicht geladen werden.",
  "hsp.empty": "Für diesen Einsatzbereich liegt derzeit kein Handschutzplan vor.",
  "hsp.plakatCreatingTitle": "Plakat wird erstellt",
  "hsp.plakatCreatingText": "Beim ersten Aufruf werden die Bilder erzeugt — das kann bis zu zwei Minuten dauern. Danach steht das Plakat sofort zur Verfügung.",
  "hsp.plakatFailedTitle": "Plakat konnte nicht erstellt werden.",
  "hsp.plakatFailedHint": "Bitte versuchen Sie es erneut. Die Textansicht steht unten zur Verfügung.",
  "hsp.plakatReload": "Plakat konnte gerade nicht geladen werden. Bitte Seite neu laden.",
  "hsp.plakatTimeout": "Die Erstellung dauert länger als erwartet. Bitte später erneut versuchen.",
  "hsp.plakatRetry": "Plakat konnte nicht erstellt werden. Bitte erneut versuchen.",
  "hsp.plakatLoadFailed": "Plakat konnte gerade nicht geladen werden.",
  "hsp.plakatImgError": "Plakat-Bild konnte nicht angezeigt werden.",
  "hsp.plakatAlt": "Handschutzplan-Plakat",
  "hsp.plakatLoadingAria": "Plakat wird geladen",
  "hsp.textOpen": "Als Text anzeigen",
  "hsp.textClose": "Textansicht schließen",
  "hsp.thWas": "Was",
  "hsp.thWann": "Wann",
  "hsp.thWomit": "Womit",
  "hsp.thWie": "Wie",
  "hsp.firstAidTitle": "Erste Hilfe bei Hautkontakt",
  "hsp.gsvOne": "1 Gefahrstoff in diesem Bereich",
  "hsp.gsvMany": "{count} Gefahrstoffe in diesem Bereich",
  "hsp.gsvMenge": "Menge im Betrieb:",
  "hsp.gsvHSaetze": "H-Sätze:",
  "hsp.psaHandschutz": "Handschutz",
  "hsp.psaAtemschutz": "Atemschutz",
  "hsp.psaAugenschutz": "Augenschutz",
  "hsp.psaKoerperschutz": "Körperschutz",
  "hsp.psaErsteHilfe": "Erste Hilfe nach Hautkontakt",
  "hsp.psaAetzReiz": "Ätz-/Reizwirkung",
  "hsp.psaSensibilisierung": "Sensibilisierung",
  "hsp.psaPSaetze": "P-Sätze",

  // Führerscheinkontrolle (Mitarbeiter)
  "fuehrerschein.title": "Führerscheinkontrolle",
  "fuehrerschein.loadError": "Aufgabe konnte nicht geladen werden.",
  "fuehrerschein.notApplicable": "Für Sie ist aktuell keine Führerscheinkontrolle vorgesehen.",
  "fuehrerschein.categoriesTitle": "Ihre Fahrzeugarten",
  "fuehrerschein.categoriesSubtitle": "Diese Fahrzeugarten hat Ihr Unternehmer für Sie festgelegt.",
  "fuehrerschein.categoriesEmpty": "Keine Kategorien zugewiesen.",
  "fuehrerschein.upToDateTitle": "Führerschein aktuell gültig",
  "fuehrerschein.upToDateText": "Im Moment steht keine Prüfung an.",
  "fuehrerschein.nextDue": "Nächste Prüfung fällig am",
  "fuehrerschein.lastDecision": "Letzte Freigabe:",
  "fuehrerschein.submittedTitle": "Einreichung erfolgreich",
  "fuehrerschein.submittedText": "Ihr Führerscheinfoto und die Erklärung liegen jetzt beim Unternehmer zur Prüfung.",
  "fuehrerschein.submittedAt": "Eingereicht am",
  "fuehrerschein.declarationTitle": "Erklärung",
  "fuehrerschein.declarationAccept": "Ich habe die Erklärung gelesen und bestätige sie.",
  "fuehrerschein.photoFrontTitle": "Führerschein-Foto: Vorderseite",
  "fuehrerschein.photoFrontHint": "Bitte die Vorderseite Ihres Führerscheins gut lesbar fotografieren (Name und Ablaufdatum sichtbar).",
  "fuehrerschein.photoBackTitle": "Führerschein-Foto: Rückseite",
  "fuehrerschein.photoBackHint": "Bitte die Rückseite Ihres Führerscheins gut lesbar fotografieren (Klassen-Tabelle sichtbar).",
  "fuehrerschein.previewFrontAlt": "Vorschau Führerschein Vorderseite",
  "fuehrerschein.previewBackAlt": "Vorschau Führerschein Rückseite",
  "fuehrerschein.otherPhoto": "Anderes Foto",
  "fuehrerschein.remove": "Entfernen",
  "fuehrerschein.pickFront": "Vorderseite aufnehmen oder Datei wählen",
  "fuehrerschein.pickBack": "Rückseite aufnehmen oder Datei wählen",
  "fuehrerschein.pickLimits": "Max. 12 MB · JPEG, PNG, WEBP, HEIC",
  "fuehrerschein.submit": "Einreichen",
  "fuehrerschein.submitting": "Einreichen…",
  "fuehrerschein.submitSuccess": "Einreichung erfolgreich.",
  "fuehrerschein.submitFailed": "Einreichung fehlgeschlagen. Bitte erneut versuchen.",
  "fuehrerschein.errFormat": "Nicht unterstütztes Bildformat. Bitte JPEG, PNG, WEBP, HEIC oder HEIF wählen.",
  "fuehrerschein.errSize": "Datei zu groß. Maximum: 12 MB.",
  "fuehrerschein.ocrPreparing": "Automatische Lesehilfe wird vorbereitet…",
  "fuehrerschein.ocrUnavailable": "OCR temporär nicht verfügbar — bitte Führerschein manuell prüfen.",
  "fuehrerschein.ocrBannerStrong": "Automatische Abschrift",
  "fuehrerschein.ocrBannerRest": " — keine Prüfung durch CLartext, ersetzt keine Sichtprüfung.",
  "fuehrerschein.ocrName": "Name (abgelesen)",
  "fuehrerschein.ocrExpiry": "Ablaufdatum (abgelesen)",
  "fuehrerschein.ocrClasses": "Klassen (abgelesen)",
};

export default de;
